import React, { useEffect, useState } from "react";

/* plugin */
import { useForm } from "react-hook-form";
import { motion } from "framer-motion";
/* plugin end */

/* service */
import formService from "../../services/formService";
/* service end */

/* component */
import ErrorMsgComp from "../../components/ErrorMsgComp";
import InnerBgComp from "../../components/InnerBgComp";
import AuthHeadingComp from "../../components/AuthHeadingComp";
import Header from "../../components/Header";
/* component end */

const CreatePassword = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm({
    mode: "all",
  });

  /* password function */
  const [eyeIcon, setEyeIcon] = useState(false);
  const [reyeIcon, setReyeIcon] = useState(false);

  const togglePassword = () => {
    setEyeIcon(!eyeIcon);
  };
  const toggleRepeatPassword = () => {
    setReyeIcon(!reyeIcon);
  };

  const password = watch("password");
  /* password function end */

  useEffect(() => {
    /* form service */
    formService.inputEmptyCheck();
    /* form service end */
  }, []);

  return (
    <div>
      {/* Header Starts */}
      <Header loginBtn={true} />
      {/* Header Ends */}

      {/* Main Container Starts */}
      <div className="main-container">
        <InnerBgComp bgImg={true} />

        {/* start */}
        <div className="comm-rev">
          <div className="container">
            {/* heading component */}
            <AuthHeadingComp />
            {/* heading component end */}

            {/* form */}
            <motion.div
              initial={{ y: 60, scale: 0.8, opacity: 0 }}
              animate={{ y: 0, scale: 1, opacity: 1 }}
              transition={{ duration: 0.5 }}
              className="form-box"
            >
              <div className="auth-hdn-box">
                <h2 className="auth-hdn">Create a password</h2>
                <div className="auth-para">
                  <p>Add your new password to regain access.</p>
                </div>
              </div>
              <form onSubmit={handleSubmit()}>
                <div className="form-grp-field">
                  <div className="form-grp int-padr">
                    <input
                      className="form-field"
                      type={eyeIcon ? "text" : "password"}
                      id="password"
                      name="password"
                      {...register("password", {
                        required: "Password is required",
                      })}
                    />
                    <p className="form-label">Password</p>
                    <i
                      className={`view-pass ${
                        eyeIcon ? "icon-eye" : "icon-eye-slash"
                      }`}
                      onClick={() => togglePassword()}
                    ></i>
                  </div>
                  {errors.password && (
                    <ErrorMsgComp errorMessage={errors.password.message} />
                  )}
                </div>
                <div className="form-grp-field">
                  <div className="form-grp int-padr">
                    <input
                      className="form-field"
                      type={reyeIcon ? "text" : "password"}
                      id="repeatPassword"
                      name="repeatPassword"
                      {...register("repeatPassword", {
                        required: "Repeat password is required",
                        validate: (value) =>
                          value === password || "The passwords do not match",
                      })}
                    />
                    <p className="form-label">Confirm password</p>
                    <i
                      className={`view-pass ${
                        reyeIcon ? "icon-eye" : "icon-eye-slash"
                      }`}
                      onClick={() => toggleRepeatPassword()}
                    ></i>
                  </div>
                  {errors.repeatPassword && (
                    <ErrorMsgComp
                      errorMessage={errors.repeatPassword.message}
                    />
                  )}
                </div>
                <button className="button button--block" type="submit">
                  <span>Sign In</span>
                </button>
              </form>
            </motion.div>
            {/* form end */}
          </div>
        </div>
        {/* end */}
      </div>
      {/* Main Container Ends */}
    </div>
  );
};

export default CreatePassword;
